import { Avatar, Chip } from "@mui/material";
import moment from "moment";
import React from "react";
import { communityHandScreenshot, communityHeart } from "src/assets";
import { useContentSetting } from "src/Hooks/ContentSettingState";

export default function UserInfoCard({
  profile_image,
  user_name,
  date,
  activity_type,
  avatar_char,
  type,
  fromCoins,
  activity,
}) {
  return (
    <>
      <div className="post-creator user-info-card">
        <div className="like-profile-image">
          <Avatar src={profile_image} alt="photoURL">
            {avatar_char}
          </Avatar>
          {(activity_type === "like" || activity_type === "gratitude") && (
            <div className="tiny-like-icon">
              {activity_type === "like" ? (
                <img src={communityHeart} alt="" />
              ) : (
                <img src={communityHandScreenshot} alt="" />
              )}
            </div>
          )}
        </div>
        <div className="creator-name ps-2 pt-1 text-start">
          <span className="d-flex feed-level post-by">
            <h3 className="mb-0">{user_name}</h3>
            {type != "member_user" && (
              <Chip
                label={type == "admin_user" ? "Admin" : "Coach"}
                color="primary"
              />
            )}
          </span>
          {fromCoins && (
            <>
              <div className="d-flex">
                <span
                  style={{
                    // marginLeft: "30px",
                    color: "var(--portal-theme-primary)",
                    fontWeight: 600,
                  }}
                >
                  Shared Coins:
                </span>
                <span
                  style={{
                    marginLeft: "5px",
                  }}
                >
                  {" "}
                  {activity?.points_earned}
                </span>
              </div>
              <div className="d-flex">
                {" "}
                <span
                  style={{
                    color: "var(--portal-theme-primary)",
                    fontWeight: 600,
                  }}
                >
                  Comment:
                </span>
                <span
                  style={{
                    marginLeft: "5px",
                  }}
                >
                  {activity?.description}
                </span>
                <br />
              </div>
            </>
          )}
          {date && (
            <span className="date-color">
              {moment(date).format("DD MMM YYYY [at] hh:mm A")}
            </span>
          )}
        </div>
      </div>
    </>
  );
}
